<template>
  <div class="SalesOrderPag page">
    <div class="page-title">
      <span>{{$t('sales_order')}}</span>
      <div class="choose-currency">
        <select v-if="$route.name !== 'global'" name="currency" v-model="currency" @change="selectCurrency">
          <option v-if="getStoreConfig() && !isNotUseStoreCurrency(getStoreConfig().currency)" :value="null">{{ getStoreConfig().currency }}</option>
          <option
            v-for="rate in (getCurrencyRates)"
            :value="rate.toCurrency"
            :key="rate.id"
          >
          {{ rate.toCurrency }}
          </option>
        </select>
      </div>
    </div>
    <UiFilterbar @onDefaultFilter="onDefaultFilter" @onFilterDay="onDefaultFilter" @onChangeOutlet="onChangeOutlet" :disableCompareDate="false" :queryMode="this.query.mode"/>
    <div class="column-filter">
      <UiReportList :reportList="reportList" />
      <div class="column-filter-wrapper">
        <button class="btn btn-csv customize-button" @click="toggleColumnFilter()">
          {{ $t('customize') }}
        </button>
        <div ref="columnsList" v-if="isShowColumnsSelect" class="content-dropdown">
          <div v-frag v-for="item in fields" :key="item.key">
            <div class="row-customize">
              <input type="checkbox" :id="item.key" @change="selectCustomize" :value="item.key" :checked="selectedCustomizes.includes(item.key)">
              <label :for="item.key">{{ item.label }}</label>
            </div>
          </div>
        </div>
    </div>
    </div>
  <UiTableOrderReport :report="orderReport" :colsData="selectedCustomizes"/>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import formatNum from 'format-num'
import { getItemByLocalStorage, setLocalStorage } from '@/utils/localStorage'
import localStorageKey from '@/constants/localStorageKey'
import UiFilterbar from '@/components/filterBar/UiFilterbar'
import UiReportList from '@/components/UiReportList'
import UiTableOrderReport from '@/components/UiTableOrderReport'
import reportType from '@/config/reportType'
import reportListData from '@/constants/reportList'
export default {
  name: 'OrderByOrderStatusPage',
  components: {
    UiFilterbar,
    UiReportList,
    UiTableOrderReport
  },
  data () {
    const timeZone = Number.isInteger(Number(new Date().getTimezoneOffset()) / 60) ? (Number(new Date().getTimezoneOffset()) < 0 ? `${`${Number(new Date().getTimezoneOffset().toString().replace('-', '')) / 60}`.padStart(2, 0)}:00` : `-${Number(new Date().getTimezoneOffset()) / 60}:00`) : (Number(new Date().getTimezoneOffset()) < 0 ? `${`${Math.trunc(Number(new Date().getTimezoneOffset().toString().replace('-', '')) / 60)}`.padStart(2, 0)}:30` : `-${Math.trunc(Number(new Date().getTimezoneOffset()) / 60)}:30`)
    return {
      currency: null,
      day: {},
      query: {
        page: 1,
        limit: 20,
        mode: 'DATE',
        outletIds: null,
        registerIds: null,
        timeZone,
        reportingMode: 'in_store',
        isSalesOrder: true,
        fieldsIncluded: ''
      },
      filterType: 'DATE',
      type: 'products',
      isShowColumnsSelect: false,
      reportList: reportListData.orders,
      fields: [
        { key: 'tipping', label: 'Tip' },
        { key: 'charge', label: 'Charge' }
      ],
      selectedCustomizes: [],
      keyTable: 0
    }
  },
  computed: {
    ...mapGetters({
      report: 'report/getReportData',
      orderReport: 'report/getOrderReportData',
      loading: 'common/loading',
      getCurrencies: 'currency/getCurrencies',
      getCurrencyRates: 'currency/getCurrencyRates',
      getQuery: 'report/getQuery'
    })
  },
  
  watch: {
    getQuery: function (newOptions) {
      if (newOptions.fieldsIncluded !== null || newOptions.fieldsIncluded !== '') {
        this.selectedCustomizes = newOptions.fieldsIncluded.split(',').filter((e) => e === 'tipping' || e === 'charge')
      }
      this.keyTable = Math.random()
    }
  },
  methods: {
    ...mapActions({
      getReport: 'report/getReportDataByStore'
    }),
    selectCurrency () {
      const currencyRate = this.getCurrencyRates.find(rate => rate.toCurrency === this.currency)

      if (currencyRate) {
        const currencySelected = this.getCurrencies.find(currencyItem => this.currency === currencyItem.code)
        const symbol = currencySelected.currency_symbol || this.currency
        var isBaseCurrency = this.getStoreConfig().currency && this.isNotUseStoreCurrency(this.getStoreConfig().currency) && this.currency === this.getStoreConfig().currency
        setLocalStorage(localStorageKey.CURRENT_CURRENCY, { ...currencyRate, symbol, rate: isBaseCurrency ? 1 : currencyRate.rate })
      }

      if (!this.currency && getItemByLocalStorage(localStorageKey.CURRENT_CURRENCY)) {
        const storeConfig = getItemByLocalStorage(localStorageKey.STORE_CONFIG)
        const currencySelected = this.getCurrencies.find(currencyItem => storeConfig?.currency === currencyItem.code)
        const symbol = currencySelected.symbol
        setLocalStorage(localStorageKey.CURRENT_CURRENCY, {
          fromCurrency: storeConfig?.currency,
          toCurrency: storeConfig?.currency,
          rate: 1,
          symbol
        })
      }
      this.getReport({
        type: reportType.orders,
        query: {
          ...this.query,
          ...this.day
        }
      })
    },
    getStoreConfig () {
      return getItemByLocalStorage(localStorageKey.STORE_CONFIG)
    },
    onChangeOutlet (reportingMode, outletIds, registerIds, day, type, states, statuses) {
      this.query.states = states
      this.query.statuses = statuses
      this.day = day
      this.query.outletIds = outletIds
      this.query.registerIds = registerIds
      this.query.reportingMode = reportingMode
      this.filterType = type
      this.query.mode = type
      this.query.showAllOrders = null
      this.query.showAllOrders = reportingMode !== 'in_store'
      this.getReport({
        type: reportType.orders,
        query: {
          ...this.query,
          ...day,
          states,
          statuses,
          mode: null,
          timeZone: this.getTimeZone()
        }
      })
    },
    onDefaultFilter (day, type, reportingMode, outletIds, registerIds, states, statuses) {
      if (outletIds) {
        this.query.outletIds = outletIds
        this.query.registerIds = registerIds
      }
      if (reportingMode) {
        this.query.reportingMode = reportingMode
        if (reportingMode === 'online') {
          this.query.outletIds = null
        }
      }
      this.filterType = type
      this.query.mode = type
      this.query.showAllOrders = null
      this.query.showAllOrders = reportingMode !== 'in_store'
      this.getReport({
        type: reportType.orders,
        query: {
          ...this.query,
          ...day,
          states,
          statuses,
          mode: null,
          timeZone: this.getTimeZone()
        }
      })
    },
    toggleColumnFilter () {
      this.isShowColumnsSelect = !this.isShowColumnsSelect
    },
    documentClick (e) {
      const el = this.$refs.columnsList
      const target = e.target
      if (el && el !== target && !el.contains(target)) {
        this.isShowColumnsSelect = false
      }
    },
    formartDate (date) {
      return moment(new Date(moment(date).toDate().toUTCString())).format('MMM DD YYYY')
    },
    formatTotal (total) {
      const storeConfig = getItemByLocalStorage(localStorageKey.STORE_CONFIG)
      const currentCurrent = getItemByLocalStorage(localStorageKey.CURRENT_CURRENCY)
      return `${currentCurrent?.symbol || storeConfig.symbol} ${formatNum((Number(total) * Number(currentCurrent?.rate || '1')).toFixed(2), { maxFraction: 2 })}`
    },
    getTimeZone () {
      return Number.isInteger(Number(new Date().getTimezoneOffset()) / 60) ? (Number(new Date().getTimezoneOffset()) < 0 ? `${`${Number(new Date().getTimezoneOffset().toString().replace('-', '')) / 60}`.padStart(2, 0)}:00` : `-${Number(new Date().getTimezoneOffset()) / 60}:00`) : (Number(new Date().getTimezoneOffset()) < 0 ? `${`${Math.trunc(Number(new Date().getTimezoneOffset().toString().replace('-', '')) / 60)}`.padStart(2, 0)}:30` : `-${Math.trunc(Number(new Date().getTimezoneOffset()) / 60)}:30`)
    },
    isNotUseStoreCurrency (currency) {
      if (currency && currency.length && this.getCurrencyRates && this.getCurrencyRates.length > 0) {
        const existCurrency = this.getCurrencyRates.find(currencyItem => currency === currencyItem.toCurrency)
        return !!existCurrency
      }
      return false
    },
    selectCustomize (e) {
      if (this.selectedCustomizes.includes(e.target.value)) {
        this.selectedCustomizes = this.selectedCustomizes.filter(item => item !== e.target.value)
      } else {
        this.selectedCustomizes.push(e.target.value)
      }
      if (this.selectedCustomizes.length > 0) {
        this.query.fieldsIncluded = this.selectedCustomizes.toString()
      } else {
        this.query.fieldsIncluded = ''
      }
      this.getReport({
        type: reportType.orders,
        query: {
          ...this.query
        }
      })
    }
  },
  created () {
    const self = this

    if (getItemByLocalStorage(localStorageKey.CURRENT_CURRENCY)) {
      this.currency = getItemByLocalStorage(localStorageKey.CURRENT_CURRENCY).toCurrency
    }

    window.addEventListener('click', function (e) {
    // close dropdown when clicked outside
      if (!self.$el.contains(e.target)) {
        self.isShowColumnsSelect = false
      }
    })
  },
  destroyed () {
    // important to clean up!!
    document.removeEventListener('click', this.documentClick)
  }
}
</script>

<style lang="scss" scoped>
  .page {
    padding: 0 30px;
  }
  .page-title {
    font-size: 36px;
    line-height: 49px;
    margin-bottom: 25px;
    display: flex;
    justify-content: space-between;
    select {
      padding: 0 15px;
      margin: 0;
      height: 39px;
      min-width: 140px;
      outline: none;
      border-radius: 4px;
      border: 1px solid #818181;
      background-color: #fff;
    }
  }
  .customize-button {
    min-width: 140px;
    font-size: 13px;
    font-weight: 600;
    outline: none;
  }
  .column-filter {
    display: flex;
    justify-content: space-between;
  }
  .column-filter-wrapper {
    text-align: right;
    position: relative;
    margin-bottom: 20px;
    padding: 0;
    .content-dropdown {
      position: absolute;
      right: 0;
      text-align: left;
      background: #e9eef1;
      padding: 10px 15px;
      top: 40px;
      width: 135px;
      border: 1px solid #acacac;
      box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
      z-index: 12;
      .row-customize {
        padding-bottom: 10px;
        padding-top: 10px;
        cursor: pointer;
      }
    }
  }
  ul {
    position: absolute;
    text-align: left;
    right: 0;
    background: #e9eef1;
    padding: 20px;
    top: 100%;
    border: 1px solid #acacac;
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
    z-index: 12;

    li {
      padding: 5px 0;

      label {
        cursor: pointer;
      }
    }
  }
</style>
